import React, { useContext, useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import LongTextComponent from "../Leads Page/LongTextComponent";
import {
  GridToolbar,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import { DataGrid } from "@mui/x-data-grid";
import {
  useMediaQuery,
  useTheme,
  Chip,
  IconButton,
  Tooltip,
  Button,
  Menu,
  MenuItem,
  Box,
  TableContainer,
  Table,
  TableHead,
  TableCell,
  TableBody,
  TableRow,
  TablePagination,
  Paper,
  TextField,
} from "@mui/material";
import axios from "axios";
import { DOWNLOAD_AND_GET_CONVERTED, GET_ESTIMATIONS_HO, HO_DOCUMENT_DOWNLOAD } from "../../constants";
import Loader from "../reusable Component/Loader";
import { useNavigate } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import DangerousIcon from "@mui/icons-material/Dangerous";
import { LoginContext } from "../LoginPage/LoginContext";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import { GridToolbarContainer } from "@mui/x-data-grid";
import DownloadIcon from "@mui/icons-material/Download";

function SharedListComponent({ finalSharedEstimationRow, setLoading }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const navigate = useNavigate();

  const [page, setPage] = useState(0); // Current page
  const [rowsPerPage, setRowsPerPage] = useState(10); // Rows per page
  const [searchTerm, setSearchTerm] = useState("");

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value.toLowerCase());
    setPage(0); // Reset page to 0 after search
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset to first page when rows per page changes
  };

  const IconCell = ({ row }) => (
    <div className={`flex m-2`}>
      {/* Download button */}
      {row.ho_document && row.ho_document.length > 0 && (
        <Tooltip title="Download" arrow>
          <IconButton
            style={{
              border: "1px solid",
              borderRadius: "4px",
              padding: "2px",
              width: "24px",
              height: "24px",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "#fff",
              marginLeft: "4px",
            }}
            color="success"
            onClick={() => handleDownload(row)} // Pass the document URL
          >
            <DownloadIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      )}
    </div>
  );

 

  // Function to handle the download
  const handleDownload = (row) => {
    setLoading(true);

    axios({
      method: "get",
      url: `${HO_DOCUMENT_DOWNLOAD}/${row.estimationId}`,
      responseType: "blob",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        setLoading(false);

        const blob = new Blob([response.data], { type: "application/zip" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;

        const filename = `Documents_${row.estimationId}_${
          new Date().toISOString().split("T")[0]
        }.zip`;
        link.setAttribute("download", filename);

        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        // Optional: Show success message
        // enqueueSnackbar('Document downloaded successfully', { variant: 'success' });
      })
      .catch((error) => {
        setLoading(false);

        // Detailed error logging and user feedback
        console.error("Download error:", error);

        let errorMessage = "Failed to download document";

        if (error.response) {
          // Check if error response is a Blob
          if (error.response.data instanceof Blob) {
            // Convert Blob to text (without await)
            error.response.data
              .text()
              .then((text) => {
                errorMessage = text;
                // enqueueSnackbar(errorMessage, { variant: 'error' });
                console.log(errorMessage);
              })
              .catch(() => {
                // enqueueSnackbar(errorMessage, { variant: 'error' });
                console.log(errorMessage);
              });
          } else {
            // Use existing error response or default message
            errorMessage = error.response.data || "Server error occurred";
            console.log(errorMessage);
            // enqueueSnackbar(errorMessage, { variant: 'error' });
          }
        } else if (error.request) {
          // The request was made but no response was received
          // enqueueSnackbar('No response received from server', { variant: 'error' });
          console.log("No response received from server");
        } else {
          // Something happened in setting up the request that triggered an Error
          // enqueueSnackbar('Error in download process', { variant: 'error' });
          console.log("Error in download process");
        }
      });
  };

  const handleIconClick = (row) => {
    navigate("/estimateDetails");
  };

  const columnsShared = [
    { field: "sno", headerName: "SNo", width: isMobile ? 30 : 50 },
    {
      field: "EstimationRequirement",
      headerName: "Estimation Requirement",
      width: isMobile ? 180 : 180,
      renderCell: (value) =>
        value === "-" ? (
          <Typography>-</Typography>
        ) : (
          <Typography
            sx={{
              textTransform: "capitalize",
              height: "20px",
              fontWeight: "700",
              fontSize: "0.8rem",
            }}
          >
            {value}
          </Typography>
        ),
    },
    {
      field: "status",
      headerName: "Status",
      width: isMobile ? 180 : 150,
      renderCell: (value) =>
        value === "-" ? (
          <Typography>-</Typography>
        ) : (
          <Chip
            size="small"
            label={value}
            color={getColorForTag(value)}
            sx={{ textTransform: "capitalize", height: "20px", margin: "10px" }}
          />
        ),
    },
    {
      field: "last_estimation_number",
      headerName: "Last Estimation Number",
      width: isMobile ? 180 : 200,
    },
    {
      field: "estimationNumber",
      headerName: "Estimation Number",
      width: isMobile ? 180 : 150,
    },
    {
      field: "estimation_amount",
      headerName: "Estimation Value",
      width: isMobile ? 180 : 150,
    },
    {
      field: "firm_farmer_name",
      headerName: "Firm/Farmer Name",
      width: isMobile ? 180 : 150,
    },
    {
      field: "Estimation_generated_date",
      headerName: "Estimation Generated Date & Time",
      width: isMobile ? 180 : 200,
    },
    {
      field: "Estimation_request_date",
      headerName: "Estimation Request Date & Time",
      width: isMobile ? 180 : 200,
    },
    {
      field: "BdmName",
      headerName: "Requested By",
      width: isMobile ? 180 : 150,
    },
    {
      field: "farmerName",
      headerName: "Farmer Name",
      width: isMobile ? 180 : 150,
    },
    {
      field: "MobNo",
      headerName: "Mobile Number",
      width: isMobile ? 180 : 150,
    },
    { field: "Project", headerName: "Project", width: isMobile ? 180 : 150 },
    {
      field: "StateName",
      headerName: "State Name",
      width: isMobile ? 180 : 150,
    },
    {
      field: "RegionName",
      headerName: "Region Name",
      width: isMobile ? 180 : 150,
    },
    {
      field: "CivilConstructedStarted",
      headerName: "Civil Construction Started",
      width: isMobile ? 180 : 150,
    },
    {
      field: "ShedLength",
      headerName: "Shed Length",
      width: isMobile ? 180 : 150,
    },
    {
      field: "EquipementPlacementLength",
      headerName: "Equipment Placement Length",
      width: isMobile ? 180 : 150,
    },
    {
      field: "ShedWidth",
      headerName: "Shed Width",
      width: isMobile ? 180 : 150,
    },
    { field: "CShape", headerName: "C-Shape", width: isMobile ? 180 : 150 },
    {
      field: "ModalType",
      headerName: "Model Type",
      width: isMobile ? 180 : 150,
    },
    {
      field: "SideWallColumnToColumnGap",
      headerName: "Side Wall Column to Column Gap",
      width: isMobile ? 180 : 250,
    },
    {
      field: "NumberOfSheds",
      headerName: "Number of Sheds",
      width: isMobile ? 180 : 150,
    },
    {
      field: "CurtainRequirment",
      headerName: "Curtain Requirement",
      width: isMobile ? 180 : 150,
    },
    {
      field: "DiselBrooderRequirment",
      headerName: "Diesel Brooder Requirement",
      width: isMobile ? 180 : 150,
    },
    {
      field: "PowerSupply",
      headerName: "Power Supply",
      width: isMobile ? 180 : 150,
    },
    {
      field: "WaterSupply",
      headerName: "Water Available",
      width: isMobile ? 180 : 150,
    },
    {
      field: "Remarks",
      headerName: "Remarks",
      width: isMobile ? 180 : 300,
      renderCell: (value) => (
        <LongTextComponent text={value || ""} maxLength={50} />
      ),
    },
    {
      field: "action",
      headerName: "Action",
      width: 80,
      renderCell: (value, row) => <IconCell row={row} />,
    },
  ];

  const getColorForTag = (tag) => {
    switch (tag.toLowerCase()) {
      case "estimation shared":
        return "secondary";
      case "revised":
        return "#ff007f";
      default:
        return "default";
    }
  };

  // Filter rows based on the search term
  const filteredRows = finalSharedEstimationRow.filter((row) =>
    Object.values(row).some(
      (value) => value && value.toString().toLowerCase().includes(searchTerm) // Case-insensitive match
    )
  );

  // Slice the rows to match pagination
  const rowsToDisplay = filteredRows.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  return (
    <>
      <Paper>
        {/* Search Field */}
        <TextField
          variant="outlined"
          size="small"
          placeholder="Search..."
          sx={{ margin: 1, float: "right" }}
          onChange={handleSearchChange}
        />
        <TableContainer
          sx={{
            boxShadow: 2,
            borderRadius: "8px",
          }}
        >
          <Table
            sx={{ minWidth: 650, tableLayout: "fixed" }}
            aria-label="simple table"
            stickyHeader
          >
            <TableHead>
              <TableRow>
                {columnsShared.map((column) => (
                  <TableCell
                    key={column.field}
                    align="center"
                    sx={{
                      backgroundColor: "#EEF0F4",
                      fontSize: "0.8rem",
                      fontWeight: "bold",
                      ...(column.field === "action" && {
                        position: "sticky",
                        right: 0,
                        zIndex: 2,
                        backgroundColor: "#EEF0F4",
                        boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                      }),
                    }}
                    width={column.width}
                  >
                    {column.headerName}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rowsToDisplay.map((row, rowIndex) => (
                <TableRow key={rowIndex}>
                  {columnsShared.map((column) => {
                    const cellValue = row[column.field];
                    return (
                      <TableCell
                        key={column.field}
                        align="center"
                        sx={{
                          ...(column.field === "action" && {
                            position: "sticky",
                            right: 0,
                            zIndex: 1,
                            backgroundColor: "#EEF0F4", // Matches table body background
                          }),
                        }}
                      >
                        {column.field === "Remarks" ? (
                          <LongTextComponent
                            text={cellValue || ""}
                            maxLength={50}
                          />
                        ) : column.field === "action" ? (
                          <IconCell row={row} />
                        ) : column.field === "status" ? (
                          <Chip
                            size="small"
                            label={cellValue}
                            color={getColorForTag(cellValue)}
                            sx={{
                              textTransform: "capitalize",
                              height: "20px",
                              margin: "10px",
                            }}
                          />
                        ) : (
                          <Typography
                            sx={{
                              textTransform: "capitalize",
                              // height: "20px",
                              fontSize: "0.8rem",
                            }}
                          >
                            {cellValue}
                          </Typography>
                        )}
                      </TableCell>
                    );
                  })}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={finalSharedEstimationRow.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </>
  );
}

export default SharedListComponent;
